import ArticleLayout from '@/components/feature/ArticleLayout';
import { safetyArticle } from '@/mocks/safetyArticle';

export default function HipobuySpreadsheetSafety() {
  return <ArticleLayout article={safetyArticle} slug="hipobuy-spreadsheet-safety" />;
}